import { render, staticRenderFns } from "./SortListArea.vue?vue&type=template&id=4640f90b&scoped=true&"
import script from "./SortListArea.vue?vue&type=script&lang=js&"
export * from "./SortListArea.vue?vue&type=script&lang=js&"
import style0 from "./SortListArea.vue?vue&type=style&index=0&id=4640f90b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640f90b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VRow,VSelect,VSpacer})
